import { IComponentOptions } from 'angular';
import { AccountSetupWizardViewController } from './account-setup-wizard-view.controller';
import template from './account-setup-wizard-view.component.html';

export const AccountSetupWizardViewComponent = {
	controller: AccountSetupWizardViewController,
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
